import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import MRegion from 'region-selector'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MainArea from "./store/mainArea";

const APIHeader = location.origin

const Api = {
    APILogin: APIHeader + "/Login",
    APIEnt: APIHeader + "/Entinfo",
    APIPsn: APIHeader + "/Psninfo",
    APIEntBin: APIHeader + "/EntBin",
    APIAsset: "https://aizhiyeasset.oss-cn-hangzhou.aliyuncs.com",
    APIA: APIHeader + "/ARole",
    APIB: APIHeader + "/BRole",
}



Vue.prototype.Api = Api

Vue.use(ElementUI);
Vue.use(MRegion);
Vue.config.productionTip = false;
import {VueJsonp} from 'vue-jsonp'
Vue.use(VueJsonp)
//日期格式化
Vue.filter('formatDate', function (value, caret) {
  let d = new Date(value);
  if (!caret) caret = "-";
  return d.getFullYear() + caret + (d.getMonth() + 1) + caret + d.getDate();
});

Vue.filter('totalSalary', function(data, caret = "-"){
  let minTotal = (data.minsalary * 12 / 10).toFixed(1);
  let maxTotal = (data.maxsalary * 12 / 10).toFixed(1);
  return minTotal + caret + maxTotal + "万";
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');